import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class UserAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Auth";
  controllerName = "api/users";
  /**
   * Lấy dữ liệu danh sách
   */
  getList(payload) {
    var param = {
      SkipCount: payload.skip || 0,
      MaxResultCount: payload.take,
      Filter: payload.filter || "",
    };
    //Nếu lấy toàn bộ dữ liệu
    if (payload.readType == 2) {
      param.IgnoreSummary = true;
    }

    let paramApi = JSON.parse(payload.condition);
    let request = {
      url: this.getAPIUrl() + `?status=${paramApi.UserStatus}&role=${paramApi.RoleUser}`,
      data: param,
    };
    return httpClient.getAsync(request);
  }
  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  loadListRole() {
    // Build tham số
    let request = {
      url: window._apis.Auth + "/api/roles",
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   *  Kiểm tra user theo email
   */
  checkByEmail(email) {
    // Build tham số
    let request = {
      url: this.getAPIUrl() + `/check?email=${email}`,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Xử lý khi nhập nội dung tìm kiếm
   */
  searchChange() {
    this.reload();
  }

  /**
   * Thêm user
   */
  insertUser(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * sửa user
   */
  updateUser(payload, id) {
    let request = {
      url: window._apis.Auth + "/api/users/" + id,
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa user
   */
  delete(record) {
    let request = {
      url: window._apis.Auth + "/api/users/" + record.Entity[0].id,
    };
    return httpClient.deleteAsync(request);
  }

  /**
   * Đổi trạng thái user
   */
  changeStatus(payload, id) {
    let request = {
      url: [this.getAPIUrl(), "/api/users", id].join("/"),
      data: payload,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Hàm chuyển đổi merchant
   * @param {string} merchantName - Mã merchant cần chuyển đổi
   * @param {string} accessToken - Access token của người dùng
   * @param {string} idType - Loại ID xác thực (MISAID_V2 nếu đăng nhập bằng MISA ID)
   */
  swapMerchant(merchantName, accessToken, idType) {
    let url = [window._apis.Auth, "/api/account/merchant-swap?merchantCode=", merchantName];

    // Thêm tham số provider=MISAID_V2 nếu đăng nhập bằng MISA ID
    // if (idType === "MISAID_V2" || localStorage.getItem("loginProvider") === "MISAID_V2") {
    //   url.push("&provider=MISAID_V2");
    // }

    url.push(`&provider=${idType}`);

    let request = {
      url: url.join(""),
      data: {
        AccessToken: accessToken,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Hàm thêm mới đơn vị
   */
  addMerchant(merchantName, accessToken) {
    let request = {
      url: [window._apis.Auth, "/api/account/merchant?merchantName=", merchantName].join(""),
      data: {
        AccessToken: accessToken,
      },
    };
    return httpClient.postAsync(request);
  }

  //#region  sub account merchant admion
  /**
   * Thêm sub user merchant admin
   */
  insertSubUserMerchant(payload) {
    let request = {
      url: this.getAPIUrl() + "/merchant",
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * sửa user
   */
  updateSubUserMerchant(payload, id) {
    let request = {
      url: window._apis.Auth + "/api/users/merchant/" + id,
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa sub user merchant admin
   */
  deleteSubUserMerchant(record) {
    let request = {
      url: window._apis.Auth + "/api/users/merchant/" + record.id,
    };
    return httpClient.deleteAsync(request);
  }

  /**
   *  Lấy dữ liệu danh sách vai trò  màn merchant
   */
  loadListRoleMerchant() {
    // Build tham số
    let request = {
      url: window._apis.Auth + "/api/roles/merchant",
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   *  Lấy dữ liệu danh sách userrole
   */
  getListUserRole() {
    // Build tham số
    let request = {
      url: window._apis.Auth + "/api/roles/user",
    };
    // Call api
    return httpClient.getAsync(request);
  }
  //#endregion
}

export default new UserAPI();
